import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import RecentNewsService from './service'

export const getRecentNewsTable = createAsyncThunk(
  'companyAnalysis/industryOverview/recentNews/getRecentNewsTable',
  async (params, { rejectWithValue }) => {
    try {
      const res = await RecentNewsService.getRecentNewsTable(params)

      return res.success ? res.data : rejectWithValue({ isLoading: false })
    } catch (error) {
      return rejectWithValue({ isLoading: axios.isCancel(error) })
    }
  },
)
